import AddPromoPackage from './AddPromoPackage';

export default AddPromoPackage;
